export const incomeYearCheck = (value: string | undefined) => {
    const stringValue = `${value}`;
    const incomeYearArray = stringValue.split('/');
    if (incomeYearArray.length !== 2 || stringValue.length !== 7) {
        return false;
    }
    const startIncomeYear = incomeYearArray[0];
    const endIncomeYear = incomeYearArray[1];

    if (parseInt(startIncomeYear) < 2006 || parseInt(startIncomeYear) > 2049 || parseInt(endIncomeYear) < 7 || parseInt(endIncomeYear) > 50) {
        return false;
    }

    if (parseInt(startIncomeYear.slice(-2)) + 1 !== parseInt(endIncomeYear)) {
        return false;
    }
    return true;
};
